import {ActionTree} from 'vuex';
import { PagedList, LavorazioneSlim, Lavorazione, EsitoAzione, MessaggioNotifica, TipoMessaggioNotifica, Utente, OrdineSlim,
  Ordine, ProgressoLavorazione, Distinta, AzioniLavorazione, Azione, LavorazionePerSpedizione, ProgressoSpedizione, EsitoOperazioneConValoreDiRitorno,
  Spedizione, FinderLavorazioni, FinderOrdini, DatiLookup, FinderSpedizioni, DatiLookupDefault, FinderDistinteStatiche, ComunicazioneVariazioneRigaDistinta,
  VariazioneRigaDistinta, Reintegro, FinderReintegri, GruppoDistinte, GruppoVenduto, FinderVenduto, FinderOrdiniMTM, OrdineMTMTestata, OrdineMTM, RequestAllegatoDownload, AggiornaDatiOrdineFornitoreRigaMTMRequest, AggiornaNoteOrdineFornitoreRigaMTMRequest, ConfermaVariazioneTestataMTMRequest, ConfermaVariazioneTestataArrayItemsRequest, ConfermaVariazioneSubArrayMTMRequest, RequestSalvaDatiAggiuntiviLavorazione, RequestSalvaDatiAggiuntiviOrdine, RequestAllegatoOrdineDownload, FinderGruppoLavorazioniPerStagione, GruppoLavorazioniPerStagione, FinderGruppoLavorazioniPerFase, GruppoLavorazioniPerFase, FinderGruppoLavorazioniPerConsegna, GruppoLavorazioniPerConsegna, FinderGruppoLavorazioniPerLotto, GruppoLavorazioniPerLotto, EsitoOperazione, TextValueItem } from '@/models';
import { hub } from '@/infrastructure/hub';
import { userService } from '@/infrastructure/user.service';
import { downloadService } from '@/infrastructure/';
import { tokenService } from '@/infrastructure/token.service';
import { RootState, FiltriLavorazioni,FiltriOrdini } from './RootState';
import { StoreMutations } from './store.mutations';
import { store } from '.';
import { RequestSchedaTecnicaDownload } from '@/models/requests/RequestSchedaTecnicaDownload';
import { OrdineSpacchettatoTestata } from '@/models/OrdineSpacchettatoTestata';
import { OrdineSpacchettatoLista } from '@/models/OrdineSpacchettatoLista';
import { OrdineSpacchettatoDettaglio } from '@/models/OrdineSpacchettatoDettaglio';

export const enum StoreActions {
  "Login" = "login",
  "Logout" = "logout",
  "RefreshUser" = "refresh",
  "WatchLavorazione" = "watchLavorazione",
  "UnwatchLavorazione" = "unwatchLavorazione",
  "WatchLavorazioni" = "watchLavorazioni",
  "UnwatchLavorazioni" = "unwatchLavorazioni",
  "WatchLavorazioniFornitore" = "watchLavorazioniFornitore",
  "UnwatchLavorazioniFornitore" = "unwatchLavorazioniFornitore",
  "WatchNotificheGruppi" = "watchNotificheGruppi",
  "UnwatchNotificheGruppi" = "unwatchNotificheGruppi",
  "GetFornitori" = "getFornitori",
  "GetDatiLookup" = "getDatiLookup",

  "GetGruppiDistinteConsumiBC" = "getGruppiDistinteConsumiBC",
  "GetDistinteStatichePerModello" = "getDistinteStatichePerModello",
  "GetLookupFiltratiConsumi" = "getLookupFiltratiConsumi",
  "ComunicaVariazioniRigheDistinteDPC" = "comunicaVariazioniRigheDistinteDPC",
  "ComunicaConfermeVariazioniRigheDistinteDPC" = "comunicaConfermeVariazioniRigheDistinteDPC",
  "ConsolidaVariazioniDistintaStatica" = "consolidaVariazioniDistintaStatica",

  "GetGruppoLavorazioniPerStagione" = "getGruppoLavorazioniPerStagione",
  "GetGruppoLavorazioniPerStagioneDataSources" = "getGruppoLavorazioniPerStagioneDataSources",
  "GetGruppoLavorazioniPerFase" = "getGruppoLavorazioniPerFase",
  "GetGruppoLavorazioniPerFaseDataSources" = "getGruppoLavorazioniPerFaseDataSources",
  "GetGruppoLavorazioniPerConsegna" = "getGruppoLavorazioniPerConsegna",
  "GetGruppoLavorazioniPerConsegnaDataSources" = "getGruppoLavorazioniPerConsegnaDataSources",
  "GetGruppoLavorazioniPerLotto" = "getGruppoLavorazioniPerLotto",
  "GetGruppoLavorazioniPerLottoDataSources" = "getGruppoLavorazioniPerLottoDataSources",

  "GetOrdiniFornitore" = "getOrdini",
  "GetOrdiniMTM" = "getOrdiniMTM",
  "GetOrdine" = "getOrdine",
  "GetOrdineMTM" = "getOrdineMTM",
  "GetOrdineSpacchettatoTestata" = "getOrdineSpacchettatoTestata",
  "GetOrdineSpacchettatoLista" = "getOrdineSpacchettatoLista",
  "GetOrdineSpacchettatoDettaglio" = "getOrdineSpacchettatoDettaglio",
  "InviaAggiornaDatiOrdineFornitoreRigaMtm" = "inviaAggiornaDatiOrdineFornitoreRigaMtm",
  "InviaAggiornaNoteConsegnaRigaMtm" = "inviaAggiornaNoteConsegnaRigaMtm",
  "ConfermaVariazioneTestataOrdineMTM" = "confermaVariazioneTestataOrdineMTM",
  "ConfermaVariazioneSubArrayOrdineMTM" = "confermaVariazioneSubArrayOrdineMTM",
  "ConfermaVariazioneArrayItemsOrdineMTM" = "confermaVariazioneArrayItemsOrdineMTM",
  "GetSpedizioniFornitore" = "getSpedizioni",
  "InviaModificaNoteOrdine" = "inviaModificaNoteOrdine",
  "InviaModificaNoteLavorazione" = "inviaModificaNoteLavorazione",
  "GetLavorazioniFornitore" = "getLavorazioniFornitore",
  "GetLavorazioni" = "getLavorazioni",
  "GetLavorazione" = "getLavorazione",
  "GetDistintaDinamicaPerLavorazione" = "getDistintaDinamica",
  "GetDistintaStaticaPerLavorazione" = "getDistintaStaticaDaStagioneModelloColorePerLavorazione",
  "GetDistintaStaticaDaId" = "getDistintaStaticaDaId",
  "GetDistintaStaticaDaIdConCorrelate" = "getDistintaStaticaDaIdConCorrelate",
  "GetDistintaStaticaDaStagioneModelloColore" = "getDistintaStaticaDaStagioneModelloColore",
  "UpdateLavorazione" = "updateLavorazione",
  "UpdateGruppoLavorazioni" = "updateGruppoLavorazioni",
  //"GetAzioniPossibiliPerLavorazione" = "getAzioniPossibiliPerLavorazione",
  "GetAzioniPossibiliPerLavorazioni" = "getAzioniPossibiliPerLavorazioni",
  "RichiediVariazioneLavorazione" = "richiediVariazioneLavorazione",
  "RichiediVariazioniLavorazioni" = "richiediVariazioniLavorazioni",
  "GetVenduto" = "getVenduto",
  "ForzaAccettazioneParteBc" = "forzaAccettazioneParteBc",
  "EseguiAzionePerLavorazione" = "eseguiAzionePerLavorazione",
  "SalvaDatiAggiuntiviOrdine" = "salvaDatiAggiuntiviOrdine",
  "SalvaDatiAggiuntiviLavorazione" = "salvaDatiAggiuntiviLavorazione",
  "AccettaLavorazione" = "accettaLavorazione",
  "ForzaConsegnaFornitoreBc" = "forzaConsegnaFornitoreBc",
  "ConsegnaFornitore" = "consegnaFornitore",
  "ConfermaConsegna" = "confermaConsegna",
  "InizioLavorazione" = "inizioLavorazione",
  "InvioProgresso" = "invioProgresso",
  "CompletaLavorazione" = "completaLavorazione",
  "RiconsegnaABc" = "riconsegnaABc",
  "RegistraRientro" = "registraRientro",

  "EseguiAzionePerLavorazioni" = "eseguiAzionePerLavorazioni",
  "AccettaLavorazioni" = "accettaLavorazioni",
  "ConsegnaFornitoreLavorazioni" = "consegnaFornitoreLavorazioni",
  "ConfermaConsegnaLavorazioni" = "confermaConsegnaLavorazioni",
  "InizioLavorazioni" = "inizioLavorazioni",
  "InvioProgressi" = "invioProgressi",
  "CompletaLavorazioni" = "completaLavorazioni",

  //SPEDIZIONI
  "GetRigheSpedizionePerFornitore" = "getRigheSpedizionePerFornitore",
  "CreaSpedizione" = "creaSpedizione",
  "GetSpedizione" = "getSpedizione",
  "AggiornaSpedizione" = "aggiornaSpedizione",
  "GetLavorazionePerRigaSpedizione" = "getLavorazionePerRigaSpedizione",
  "GetLavorazionePerRigaSpedizioneDaLid" = "getLavorazionePerRigaSpedizioneDaLid",
  "AggiungiRigaSpedizioneDaLavorazione" = "aggiungiRigaSpedizioneDaLavorazione",
  "AggiungiRigaSpedizioneDaEpcLavorazione" = "aggiungiRigaSpedizioneDaEpcLavorazione",
  "EliminaRigaSpedizioneDaLavorazione" = "eliminaRigaSpedizioneDaLavorazione",
  "EliminaSpedizione" = "eliminaSpedizione",
  "DownloadCSVPackingList" = "downloadCSVPackingList",
  "DownloadCSVPackingListExtended" = "downloadCSVPackingListExtended",

  "GetReintegri" = "getReintegri",
  "GetReintegro" = "getReintegro",
  "DownloadCSVReintegro" = "downloadCSVReintegro",
  "DownloadCSVVenduto" = "downloadCSVVenduto",
  "DownloadCSVDistintaDinamica" = "downloadCSVDistintaDinamica",
  "DownloadXLSXPackingListLavorazione" = "downloadXLSXPackingListLavorazione",
  "DownloadXLSXPackingListLavorazioneSpacchettato" = "downloadXLSXPackingListLavorazioneSpacchettato",
  "DownloadXLSXPackingListOrdine" = "downloadXLSXPackingListOrdine",
  "DownloadAllegato" = "downloadAllegato",
  "DownloadAllegatoOrdine" = "downloadAllegatoOrdine",
  "GetModelliSchedeDaModelloEStagione" = "getModelliSchedeDaModelloEStagione",
  "DownloadSchedaTecnica" = "downloadSchedaTecnica",

  //STAMPA ETICHETTE
  "StampaEtichettaPerLavorazioneETaglia" = "stampaEtichettaPerLavorazioneETaglia",
  "OperazioniEtichetteDremeDisponibiliPerLavorazione" = "operazioniEtichetteDremeDisponibiliPerLavorazione",
  "StampaEtichettePerOrdine" = "stampaEtichettePerOrdine",
  "StampaEtichettePerOrdineMTM" = "stampaEtichettePerOrdineMTM",
  "OperazioniEtichetteDremeDisponibiliPerOrdine" = "operazioniEtichetteDremeDisponibiliPerOrdine",
  "GetResetEPCDisponibile" = "getResetEPCDisponibile",
  "GetStampaEtichetteRfidDisponibile" = "getStampaEtichetteRfidDisponibile",
  "GetStampaEtichetteNoRfidDisponibile" = "getStampaEtichetteNoRfidDisponibile",
}

export default {

  async login({commit, dispatch}, loginData: any): Promise<boolean> {

    var result = false;

    try {
      commit(StoreMutations.SetLoading, true);
      // chiamata login... se ok ritorna token e utente
      var authData = await userService.login(loginData.username, loginData.password);

      if(authData && authData.token && authData.user) {
        tokenService.saveToken(authData.token);
        commit(StoreMutations.SetLoggedUser, authData.user);

        // dopo autenticazione utente, inizializzazione connessione hub
        result = await hub.init();

        if(!result) {
          await dispatch(StoreActions.Logout);
        }
        else {
          // contestualmente per l'utente loggato vengono anche caricati i suoi dati di lookup
          await store.dispatch(StoreActions.GetDatiLookup);
        }
      }
    }
    catch(error) {
      console.error("errore login: " + error);
      await dispatch(StoreActions.Logout);
    }

    commit(StoreMutations.SetLoading, false);
    return result;
  },
  async logout({commit}): Promise<boolean> {

    var result = false;

    try {
      commit(StoreMutations.SetLoading, true);

      // rimozione token
      tokenService.removeToken();
      // rimozione utente corrente
      commit(StoreMutations.SetLoggedUser);
      // reset store locale
      commit(StoreMutations.ResetStore);
      // chiusura connessione hub
      await hub.close();

      result = true;
    }
    catch(error) {
      console.error("errore logout: " + error);
    }

    commit(StoreMutations.SetLoading, false);
    return result;
  },
  async refresh({commit, dispatch}): Promise<boolean> {

    var result = false;

    try {
      commit(StoreMutations.SetLoading, true);
      // chiamata login... se ok ritorna token e utente
      var authData = await userService.refreshUser();

      if(authData && authData.data) {
        commit(StoreMutations.SetLoggedUser, authData.data);

        // dopo refresh utente, inizializzazione connessione hub
        result = await hub.init();

        if(!result) {
          await dispatch(StoreActions.Logout);
        }
        else {
          // contestualmente per l'utente loggato vengono anche caricati i suoi dati di lookup
          await store.dispatch(StoreActions.GetDatiLookup);
        }
      }
    }
    catch(error) {
      console.error("errore login: " + error);
      await dispatch(StoreActions.Logout);
    }

    commit(StoreMutations.SetLoading, false);
    return result;
  },
    async watchLavorazione({commit}, id: string): Promise<any> {
      try {
        await hub.watchLavorazione(id);
      }
      catch(error) {
        console.error("errore avvio monitoraggio lavorazione: " + error);
      }
    },
    async unwatchLavorazione({commit}, id: string): Promise<any> {
      try {
        if(id && id.trim().length > 0) {
          await hub.unwatchLavorazione(id);
        }
      }
      catch(error) {
        console.error("errore arresto monitoraggio lavorazione: " + error);
      }
    },
    async watchLavorazioni({commit}, ids: string[]): Promise<any> {
      try {
        if(ids && ids.length > 0) {
          await hub.watchLavorazioni(ids);
        }
      }
      catch(error) {
        console.error("errore avvio monitoraggio lavorazioni: " + error);
      }
    },
    async unwatchLavorazioni({commit}, ids: string[]): Promise<any> {
      try {
        if(ids && ids.length > 0) {
          await hub.unwatchLavorazioni(ids);
        }
      }
      catch(error) {
        console.error("errore arresto monitoraggio lavorazioni: " + error);
      }
    },
    async watchLavorazioniFornitore({commit}, idFornitore: string): Promise<any> {
      try {
        await hub.watchLavorazioniFornitore(idFornitore);
      }
      catch(error) {
        console.error("errore avvio monitoraggio lavorazioni: " + error);
      }
    },
    async unwatchLavorazioniFornitore({commit}, idFornitore: string): Promise<any> {
      try {
        await hub.unwatchLavorazioniFornitore(idFornitore);
      }
      catch(error) {
        console.error("errore arresto monitoraggio lavorazioni: " + error);
      }
    },
    async watchNotificheGruppi(): Promise<any> {
      try {
        await hub.watchNotificheGruppi();
      }
      catch(error) {
        console.error("errore avvio monitoraggio notifiche per operazioni su gruppi: " + error);
      }
    },
    async unwatchNotificheGruppi(): Promise<any> {
      try {
        await hub.unwatchNotificheGruppi();
      }
      catch(error) {
        console.error("errore arresto monitoraggio notifiche per operazioni su gruppi: " + error);
      }
    },
    async getFornitori({commit}, idFornitore: string): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let utenti: Utente[] = await hub.getUtenti();
        let fornitori = utenti.filter(u => u.fornitore);
        commit(StoreMutations.SetFornitori, fornitori);
      }
      catch(error) {
        console.error("errore lettura ordini: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async getRigheSpedizionePerFornitore({commit}, idFornitore: string): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let lavorazioniSpedizione: LavorazionePerSpedizione[] = await hub.getRigheSpedibiliPerFornitore(idFornitore);
        commit(StoreMutations.SetLavorazioniPerSpedizione, lavorazioniSpedizione);
      }
      catch(error) {
        console.error("errore lettura righe per spedizione: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async creaSpedizione({commit}, datiSpedizione: Spedizione): Promise<[boolean, string]> {
      let errori: MessaggioNotifica[] = [];
      let esito = {} as EsitoOperazioneConValoreDiRitorno;
      try {
        commit(StoreMutations.SetLoading, true);
        esito = await hub.creaSpedizione(datiSpedizione.numeroDDT, datiSpedizione.dataDDT, datiSpedizione.numeroColli, datiSpedizione.note);
        //commit(StoreMutations.SetLavorazioniPerSpedizione, lavorazioniSpedizione);
        if(!esito.eseguitaConSuccesso) {
          esito.errori.map(err => { return {
            tipo: TipoMessaggioNotifica.Errore,
            message: err,
            showed: false
          }})
          .forEach(msg => errori.push(msg));
        }

      }
      catch(error) {
        console.error("errore creazione spedizione: " + error);
        commit(StoreMutations.SetLoading, false);
        return[false, '']
      }
      commit(StoreMutations.SetLoading, false);

      if(errori.length > 0) {
        commit(StoreMutations.AddMessaggi, errori);
        return [false, ''];
      } else{
        commit(StoreMutations.AddMessaggi, [{
          message: "Spedizione salvata con successo",
          tipo: TipoMessaggioNotifica.Info,
          showed: false,
        } as MessaggioNotifica]);
      }
      return [true, esito.valoreDiRitorno];
    },

    async aggiornaSpedizione({commit}, datiSpedizione: Spedizione): Promise<boolean> {
      let errori: MessaggioNotifica[] = [];
      let esito = {} as EsitoOperazione;
      try {
        commit(StoreMutations.SetLoading, true);
        esito = await hub.aggiornaSpedizione(datiSpedizione);
        //commit(StoreMutations.SetLavorazioniPerSpedizione, lavorazioniSpedizione);
        if(!esito.eseguitaConSuccesso) {
          esito.errori.map(err => { return {
            tipo: TipoMessaggioNotifica.Errore,
            message: err,
            showed: false
          }})
          .forEach(msg => errori.push(msg));
        }

      }
      catch(error) {
        console.error("errore creazione spedizione: " + error);
        commit(StoreMutations.SetLoading, false);
        return false
      }
      commit(StoreMutations.SetLoading, false);

      if(errori.length > 0) {
        commit(StoreMutations.AddMessaggi, errori);
        return false;
      } else{
        commit(StoreMutations.AddMessaggi, [{
          message: "Spedizione salvata con successo",
          tipo: TipoMessaggioNotifica.Info,
          showed: false,
        } as MessaggioNotifica]);
      }
      return true;
    },
    async getSpedizione({commit}, id: string): Promise<Spedizione> {
      let spedizione!: Spedizione;
      try {
        commit(StoreMutations.SetLoading, true);
        let sped = await hub.getSpedizione(id);
        if(sped) {
          spedizione = sped;
          commit(StoreMutations.SetSpedizione, spedizione);
        }
      }
      catch(error) {
        console.error("errore lettura ordini: " + error);
      }
      commit(StoreMutations.SetLoading, false);

      return spedizione;
    },

    async getReintegri({commit}, finder: FinderReintegri): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let paginaReintegri: PagedList<Reintegro> = await hub.getReintegri(finder);
        commit(StoreMutations.SetReintegri, paginaReintegri);
      }
      catch(error) {
        console.error("errore lettura reintegri: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async getReintegro({commit}, id: string): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        // caricamento lavorazione
        let reintegro: Reintegro | null = await hub.getReintegro(id);
        commit(StoreMutations.SetReintegro, reintegro);
      }
      catch(error) {
        console.error("errore lettura reintegro: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async downloadCSVReintegro({commit, dispatch}, reintegroData: any): Promise<any> {
      let ret = undefined;
      try {
        commit(StoreMutations.SetReintegroCSVButtonLoading, true);

        let response = await downloadService.CSVReintegro(reintegroData.idReintegro);
        if(response){
          if(response.ok){
            ret = await response.blob();
          } else {
            let res  = await response.json();
            commit(StoreMutations.AddMessaggi, [{
              tipo: TipoMessaggioNotifica.Errore,
              message: `[Status ${response.status.toString()}]: ${res.Message}`,
              showed: false
            }]);
          }
        } else {
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Errore,
            message: 'Token di autenticazione non trovato',
            showed: false
          }]);
        }

        commit(StoreMutations.SetReintegroCSVButtonLoading, false);
      }
      catch(error) {
        console.error("errore download: " + error);
      }

      return ret;
    },
    async downloadCSVVenduto({commit, dispatch}, finderVenduto: FinderVenduto): Promise<any> {
      let ret = undefined;
      try {
        commit(StoreMutations.SetVendutoCSVButtonLoading, true);

        let response = await downloadService.CSVVenduto(finderVenduto);
        if(response){
          if(response.ok){
            ret = await response.blob();
          } else {
            let res  = await response.json();
            commit(StoreMutations.AddMessaggi, [{
              tipo: TipoMessaggioNotifica.Errore,
              message: `[Status ${response.status.toString()}]: ${res.Message}`,
              showed: false
            }]);
          }
        } else {
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Errore,
            message: 'Token di autenticazione non trovato',
            showed: false
          }]);
        }

        commit(StoreMutations.SetVendutoCSVButtonLoading, false);
      }
      catch(error) {
        console.error("errore download: " + error);
      }

      return ret;
    },
    async downloadCSVDistintaDinamica({commit}, idDiba: string): Promise<any> {
      let ret = undefined;
      try {
        commit(StoreMutations.SetDistintaDinamicaCSVButtonLoading, true);

        let response = await downloadService.CSVDistintaDinamica(idDiba);
        if(response){
          if(response.ok){
            ret = await response.blob();
          } else {
            let res  = await response.json();
            commit(StoreMutations.AddMessaggi, [{
              tipo: TipoMessaggioNotifica.Errore,
              message: `[Status ${response.status.toString()}]: ${res.Message}`,
              showed: false
            }]);
          }
        } else {
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Errore,
            message: 'Token di autenticazione non trovato',
            showed: false
          }]);
        }

      }
      catch(error) {
        commit(StoreMutations.AddMessaggi, [{
          tipo: TipoMessaggioNotifica.Errore,
          message: "Errore download: " + error,
          showed: false
        }]);
      }
      finally
      {
        commit(StoreMutations.SetDistintaDinamicaCSVButtonLoading, false);
      }

      return ret;
    },
    async downloadXLSXPackingListLavorazione({commit}, idLavorazione: string): Promise<any> {
      let ret = undefined;
      try {
        commit(StoreMutations.SetXlsxPackingListLavorazioneLoading, true);

        let response = await downloadService.XLSXPackingListLavorazione(idLavorazione);
        if(response){
          if(response.ok){
            ret = await response.blob();
          } else {
            let res  = await response.json();
            commit(StoreMutations.AddMessaggi, [{
              tipo: TipoMessaggioNotifica.Errore,
              message: `[Status ${response.status.toString()}]: ${res.Message}`,
              showed: false
            }]);
          }
        } else {
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Errore,
            message: 'Token di autenticazione non trovato',
            showed: false
          }]);
        }

      }
      catch(error) {
        console.dir(error);
        
        commit(StoreMutations.AddMessaggi, [{
          tipo: TipoMessaggioNotifica.Errore,
          message: "Errore download: " + error,
          showed: false
        }]);
      }
      finally
      {
        commit(StoreMutations.SetXlsxPackingListLavorazioneLoading, false);
      }

      return ret;
    },
    async downloadXLSXPackingListLavorazioneSpacchettato({commit}, data: {idLavorazione: string, idOrdine: string }): Promise<any> {
      let ret = undefined;
      try {
        commit(StoreMutations.SetXlsxPackingListLavorazioneSpacchettatoLoading, { idLavorazione: data.idLavorazione, isLoading: true});

        let response = await downloadService.XLSXPackingListLavorazioneSpacchettato(data.idLavorazione, data.idOrdine);
        if(response){
          if(response.ok){
            ret = await response.blob();
          } else {
            let res  = await response.json();
            commit(StoreMutations.AddMessaggi, [{
              tipo: TipoMessaggioNotifica.Errore,
              message: `[Status ${response.status.toString()}]: ${res.Message}`,
              showed: false
            }]);
          }
        } else {
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Errore,
            message: 'Token di autenticazione non trovato',
            showed: false
          }]);
        }

      }
      catch(error) {
        commit(StoreMutations.AddMessaggi, [{
          tipo: TipoMessaggioNotifica.Errore,
          message: "Errore download: " + error,
          showed: false
        }]);
      }
      finally
      {
        commit(StoreMutations.SetXlsxPackingListLavorazioneSpacchettatoLoading, { idLavorazione: data.idLavorazione, isLoading: false});
      }

      return ret;
    },
    
    async downloadXLSXPackingListOrdine({commit}, idOrdine: string): Promise<any> {
      let ret = undefined;
      try {
        commit(StoreMutations.SetXlsxPackingListOrdineLoading, true);

        let response = await downloadService.XLSXPackingListOrdine(idOrdine);
        if(response){
          if(response.ok){
            ret = await response.blob();
          } else {
            let res  = await response.json();
            commit(StoreMutations.AddMessaggi, [{
              tipo: TipoMessaggioNotifica.Errore,
              message: `[Status ${response.status.toString()}]: ${res.Message}`,
              showed: false
            }]);
          }
        } else {
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Errore,
            message: 'Token di autenticazione non trovato',
            showed: false
          }]);
        }

      }
      catch(error) {
        console.dir(error);
        
        commit(StoreMutations.AddMessaggi, [{
          tipo: TipoMessaggioNotifica.Errore,
          message: "Errore download: " + error,
          showed: false
        }]);
      }
      finally
      {
        commit(StoreMutations.SetXlsxPackingListOrdineLoading, false);
      }

      return ret;
    },
    async downloadCSVPackingList({commit}, idSpedizione: string): Promise<any> {
      let ret = undefined;
      try {
        commit(StoreMutations.SetSpedizioneCSVDownloadButtonLoading, true);

        let response = await downloadService.CSVSpedizionePackingList(idSpedizione);
        if(response){
          if(response.ok){
            ret = await response.blob();
          } else {
            let res  = await response.json();
            commit(StoreMutations.AddMessaggi, [{
              tipo: TipoMessaggioNotifica.Errore,
              message: `[Status ${response.status.toString()}]: ${res.Message}`,
              showed: false
            }]);
          }
        } else {
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Errore,
            message: 'Token di autenticazione non trovato',
            showed: false
          }]);
        }

      }
      catch(error) {
        commit(StoreMutations.AddMessaggi, [{
          tipo: TipoMessaggioNotifica.Errore,
          message: "Errore download: " + error,
          showed: false
        }]);
      }
      finally
      {
        commit(StoreMutations.SetSpedizioneCSVDownloadButtonLoading, false);
      }

      return ret;
    },
    async downloadCSVPackingListExtended({commit}, idSpedizione: string): Promise<any> {
      let ret = undefined;
      try {
        commit(StoreMutations.SetSpedizioneCSVDownloadButtonLoading, true);

        let response = await downloadService.CSVSpedizionePackingListExtended(idSpedizione);
        if(response){
          if(response.ok){
            ret = await response.blob();
          } else {
            let res  = await response.json();
            commit(StoreMutations.AddMessaggi, [{
              tipo: TipoMessaggioNotifica.Errore,
              message: `[Status ${response.status.toString()}]: ${res.Message}`,
              showed: false
            }]);
          }
        } else {
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Errore,
            message: 'Token di autenticazione non trovato',
            showed: false
          }]);
        }

      }
      catch(error) {
        commit(StoreMutations.AddMessaggi, [{
          tipo: TipoMessaggioNotifica.Errore,
          message: "Errore download: " + error,
          showed: false
        }]);
      }
      finally
      {
        commit(StoreMutations.SetSpedizioneCSVDownloadButtonLoading, false);
      }

      return ret;
    },
    async downloadAllegato({commit, dispatch}, request: RequestAllegatoDownload): Promise<any> {
      let ret = undefined;
      try {
        commit(StoreMutations.SetAllegatoOrdineMTMDownloadButtonLoading, request.idAllegato);

        let response = await downloadService.downloadAllegato(request.idAllegato?.toString() ?? "", request.fornitore ?? "");
        if(response){
          if(response.ok){
            ret = await response.blob();
          } else {
            let res  = await response.json();
            commit(StoreMutations.AddMessaggi, [{
              tipo: TipoMessaggioNotifica.Errore,
              message: `[Status ${response.status.toString()}]: ${res}`,
              showed: false
            }]);
          }
        } else {
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Errore,
            message: 'Token di autenticazione non trovato',
            showed: false
          }]);
        }

        commit(StoreMutations.SetAllegatoOrdineMTMDownloadButtonLoading, 0);
      }
      catch(error) {
        console.error("errore download: " + error);
      }

      return ret;
    },
    async downloadAllegatoOrdine({commit, dispatch}, request: RequestAllegatoOrdineDownload): Promise<any> {
      let ret = undefined;
      try {
        commit(StoreMutations.SetAllegatoOrdineDownloadButtonLoading, true);

        let response = await downloadService.downloadAllegatoOrdine(request.lam ?? "");
        if(response){
          if(response.ok){
            ret = await response.blob();
          } else {
            let res  = await response.json();
            commit(StoreMutations.AddMessaggi, [{
              tipo: TipoMessaggioNotifica.Errore,
              message: `[Status ${response.status.toString()}]: ${res}`,
              showed: false
            }]);
          }
        } else {
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Errore,
            message: 'Token di autenticazione non trovato',
            showed: false
          }]);
        }

        commit(StoreMutations.SetAllegatoOrdineDownloadButtonLoading, false);
      }
      catch(error) {
        console.error("errore download: " + error);
      }

      return ret;
    },
    async downloadSchedaTecnica({commit, dispatch}, request: RequestSchedaTecnicaDownload): Promise<any> {
      let ret = undefined;
      try {
        commit(StoreMutations.SetSchedaTecnicaDownloading, true);

        let response = await downloadService.downloadSchedaTecnicaModello(request.templateScheda, request.modello, request.stagione );
        if(response){
          if(response.ok){
            ret = await response.blob();
          } else {
            let res  = await response.json();
            if(response.status == 404){
              commit(StoreMutations.AddMessaggi, [{
                tipo: TipoMessaggioNotifica.Warning,
                message: `File non trovato`,
                showed: false
              }]);
            } else{
              commit(StoreMutations.AddMessaggi, [{
                tipo: TipoMessaggioNotifica.Errore,
                message: `[Status ${response.status.toString()}]: ${res}`,
                showed: false
              }]);
            }
          }
        } else {
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Errore,
            message: 'Token di autenticazione non trovato',
            showed: false
          }]);
        }

      }
      catch(error) {
        console.error("errore download: " + error);
      }
      finally{
        commit(StoreMutations.SetSchedaTecnicaDownloading, false);
      }

      return ret;
    },
    async getDatiLookup({commit}): Promise<DatiLookup> {
      let dati: DatiLookup = DatiLookupDefault;

      try {
        commit(StoreMutations.SetLoading, true);

        dati = await hub.getDatiLookup();

        commit(StoreMutations.SetDatiLookup, dati);
      }
      catch(error) {
        console.error("errore lettura dati lookup fornitore: " + error);
      }
      commit(StoreMutations.SetLoading, false);

      return dati;
    },
    async getGruppiDistinteConsumiBC({commit}, finder: FinderDistinteStatiche): Promise<any> {
      let distinte!: PagedList<GruppoDistinte>;

      try {
        commit(StoreMutations.SetLoading, true);

        distinte = await hub.getGruppiDistinteStatiche(finder);

        commit(StoreMutations.SetGruppiDistinteConsumiBC, distinte);
      }
      catch(error) {
        console.error("errore lettura gruppi distinte: " + error);
      }
      commit(StoreMutations.SetLoading, false);

      return distinte;
    },
    async getDistintaStaticaDaId({state, commit}, id: string): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let distinta = await hub.getDistintaStaticaDaId(id);
        commit(StoreMutations.SetDistintaStatica, distinta);
      }
      catch(error) {
        console.error("errore caricamento distinta statica: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async getDistintaStaticaDaIdConCorrelate({state, commit}, id: string): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);

        let distinta = await hub.getDistintaStaticaDaId(id);
        commit(StoreMutations.SetDistintaStatica, distinta);

        let distinteCorrelate = await hub.getDistinteStatichePerModello(distinta.idModello);
        commit(StoreMutations.SetDistinteStaticheCorrelate, distinteCorrelate);
      }
      catch(error) {
        console.error("errore caricamento distinta statica: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async getDistinteStatichePerModello({commit}, idModello: string): Promise<any> {
      try {
        //commit(StoreMutations.SetLoading, true);

        let distinte = await hub.getDistinteStatichePerModello(idModello);

        commit(StoreMutations.SetDistinteStaticheCorrelate, distinte);
      }
      catch(error) {
        console.error("errore lettura distinte correlate per modello: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async comunicaVariazioniRigheDistinteDPC({commit}, comunicazioni : ComunicazioneVariazioneRigaDistinta[]) : Promise<boolean> {
      let risultato : boolean = false;
      try {
        commit(StoreMutations.SetLoading, true);

        await hub.comunicaVariazioniRigheDistinteDPC(comunicazioni);

        let distinta = await hub.getDistintaStaticaDaId(comunicazioni[0].idDistinta);
        commit(StoreMutations.SetDistintaStatica, distinta);

        let distinteCorrelate = await hub.getDistinteStatichePerModello(distinta.idModello);
        commit(StoreMutations.SetDistinteStaticheCorrelate, distinteCorrelate);

        risultato = true;
      }
      catch(error) {
        console.error("errore comunicazione variazioni per distinta: " + error);
      }
      commit(StoreMutations.SetLoading, false);

      return risultato;
    },

    async comunicaConfermeVariazioniRigheDistinteDPC({commit}, params:{variazioniConfermate : ComunicazioneVariazioneRigaDistinta[], idDistinta: string}) : Promise<boolean> {
      let risultato : boolean = false;
      try {
        commit(StoreMutations.SetLoading, true);

        risultato = await hub.comunicaConfermeVariazioniRigheDistinteDPC(params.variazioniConfermate);

        let distinta = await hub.getDistintaStaticaDaId(params.idDistinta);
        commit(StoreMutations.SetDistintaStatica, distinta);

        let distinteCorrelate = await hub.getDistinteStatichePerModello(distinta.idModello);
        commit(StoreMutations.SetDistinteStaticheCorrelate, distinteCorrelate);

        if (risultato){
          let messaggi : MessaggioNotifica[] = [
            {
              tipo: TipoMessaggioNotifica.Info,
              message: `Sono stati generati nuovi reintegri.`,
              showed: false
            }
          ]
          commit(StoreMutations.AddMessaggi, messaggi);
        }
      }
      catch(error) {
        console.error("errore comunicazione conferme variazioni per distinta: " + error);
      }
      commit(StoreMutations.SetLoading, false);

      return risultato;
    },

    async consolidaVariazioniDistintaStatica({commit}, idDistinta: string) : Promise<boolean> {
      let risultato : boolean = false;
      try {
        commit(StoreMutations.SetLoading, true);

        let distintaAggiornata = await hub.consolidaVariazioniDistintaStatica(idDistinta);

        commit(StoreMutations.SetDistintaStatica, distintaAggiornata);

        risultato = true;
      }
      catch(error) {
        console.error("errore consolidamento distinta statica: " + error);
      }
      commit(StoreMutations.SetLoading, false);

      return risultato;
    },

    async getOrdiniMTM({commit}, finder: FinderOrdiniMTM): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let paginaOrdini: PagedList<OrdineMTMTestata> = await hub.getOrdiniMTM(finder);
        commit(StoreMutations.SetOrdiniMTM, paginaOrdini);
      }
      catch(error) {
        console.error("errore lettura ordini: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },

    async getOrdini({commit}, finder: FinderOrdini): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let paginaOrdini: PagedList<OrdineSlim> = await hub.getOrdini(finder);
        commit(StoreMutations.SetOrdini, paginaOrdini);
      }
      catch(error) {
        console.error("errore lettura ordini: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    //pagina: number, idFornitore: string, filtri: FiltriOrdini
    async getOrdine({commit}, id: string): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);

        let ordine: Ordine | null = await hub.getOrdine(id);
        commit(StoreMutations.SetOrdine, ordine);

        // let azioni: string[] = await hub.getAzioniPossibiliPerLavorazione(id);
        // commit(StoreMutations.SetAzioniLavorazione, azioni);
      }
      catch(error) {
        console.error("errore lettura ordine: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async getOrdineMTM({commit}, id: string): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);

        let ordine: OrdineMTM | null = await hub.getOrdineMTM(id);
        commit(StoreMutations.SetOrdineMTM, ordine);
      }
      catch(error) {
        console.error("errore lettura ordine MTM: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async getOrdineSpacchettatoTestata({commit}, id: string): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);

        let ordine: OrdineSpacchettatoTestata | null = await hub.getOrdineSpacchettatoTestata(id);
        commit(StoreMutations.SetOrdineSpacchettatoTestata, ordine);
      }
      catch(error) {
        console.error("errore lettura ordine spacchettato: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async getOrdineSpacchettatoLista({commit}, dati: { stagione: string, linea: string, numeroOrdine: string, page: number, pageSize: number}): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);

        let ordine: OrdineSpacchettatoLista[] | null = await hub.getOrdineSpacchettatoLista( dati.stagione, dati.linea, dati.numeroOrdine, dati.page, dati.pageSize);
        
        commit(StoreMutations.SetOrdineSpacchettatoLista, ordine);
      }
      catch(error) {
        console.error("errore lettura ordine Spacchettato lista: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async getOrdineSpacchettatoDettaglio({commit}, dati: { idLids: string[], page: number, pageSize: number}): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);

        let ordine: OrdineSpacchettatoDettaglio[] | null = await hub.getOrdineSpacchettatoDettaglio(dati.idLids, dati.page, dati.pageSize);
        
        commit(StoreMutations.SetOrdineSpacchettatoDettaglio, ordine);
      }
      catch(error) {
        console.error("errore lettura ordine Spacchettato dettaglio: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    
    async inviaModificaNoteOrdine({commit}, noteOrdine: { idOrdine: string, note: string}): Promise<boolean> {
      let completed = false;

      try {
        commit(StoreMutations.SetLoading, true);

        completed = await hub.updateNoteOrdine(noteOrdine.idOrdine, noteOrdine.note);

        if(completed) {
          commit(StoreMutations.AggiornaNoteOrdine, noteOrdine);
        }
      }
      catch(error) {
        console.error("errore aggiornamento note ordine: " + error);
        completed = false;
      }
      commit(StoreMutations.SetLoading, false);

      return completed;
    },
    async inviaModificaNoteLavorazione({commit}, noteLavorazione: { idLavorazione: string, note: string}): Promise<boolean> {
      let completed = false;

      try {
        commit(StoreMutations.SetLoading, true);

        completed = await hub.updateNoteLavorazione(noteLavorazione.idLavorazione, noteLavorazione.note);

        if(completed) {
          commit(StoreMutations.AggiornaNoteLavorazione, noteLavorazione);
        }
      }
      catch(error) {
        console.error("errore aggiornamento note lavorazione: " + error);
        completed = false;
      }
      commit(StoreMutations.SetLoading, false);

      return completed;
    },
    async inviaAggiornaDatiOrdineFornitoreRigaMtm({commit}, request: AggiornaDatiOrdineFornitoreRigaMTMRequest): Promise<boolean> {
      let completed = false;

      try {
        commit(StoreMutations.SetLoading, true);

        const result = await hub.updateDatiOrdineFornitoreRigaMtm(request);
        completed = result.eseguitaConSuccesso;

        if(completed) {
          let ordine: OrdineMTM | null = await hub.getOrdineMTMDaIdTestata(request.idTestataMtm.toString());
          commit(StoreMutations.SetOrdineMTM, ordine);
        } else{
          commit(StoreMutations.AddMessaggi, result.errori.map( e => {return {
            tipo: TipoMessaggioNotifica.Errore,
            message: e,
            showed: false
          }}));
        }
      }
      catch(error) {
        console.error("errore aggiornamento ordine fornitore MTM: " + error);
        completed = false;
      }
      commit(StoreMutations.SetLoading, false);

      return completed;
    },
    async inviaAggiornaNoteConsegnaRigaMtm({commit}, request: AggiornaNoteOrdineFornitoreRigaMTMRequest): Promise<boolean> {
      let completed = false;

      try {
        commit(StoreMutations.SetLoading, true);

        const result = await hub.updateNoteConsegnaRigaMtm(request);
        completed = result.eseguitaConSuccesso;

        if(completed) {
          let ordine: OrdineMTM | null = await hub.getOrdineMTMDaIdTestata(request.idTestataMtm.toString());
          commit(StoreMutations.SetOrdineMTM, ordine);
        } else{
          commit(StoreMutations.AddMessaggi, result.errori.map( e => {return {
            tipo: TipoMessaggioNotifica.Errore,
            message: e,
            showed: false
          }}));
        }
      }
      catch(error) {
        console.error("errore aggiornamento note consegna ordine fornitore MTM: " + error);
        completed = false;
      }
      commit(StoreMutations.SetLoading, false);

      return completed;
    },
    async confermaVariazioneTestataOrdineMTM({commit}, request: ConfermaVariazioneTestataMTMRequest): Promise<boolean> {
      let completed = false;

      try {
        commit(StoreMutations.SetLoading, true);

        const result = await hub.confermaVariazioneTestataOrdineMTM(request);
        completed = result.eseguitaConSuccesso;

        if(completed) {
          let ordine: OrdineMTM | null = await hub.getOrdineMTM(request.idOrdine);
          commit(StoreMutations.SetOrdineMTM, ordine);
        } else{
          commit(StoreMutations.AddMessaggi, result.errori.map( e => {return {
            tipo: TipoMessaggioNotifica.Errore,
            message: e,
            showed: false
          }}));
        }
      }
      catch(error) {
        console.error("errore aggiornamento variazione testata ordine MTM: " + error);
        completed = false;
      }
      commit(StoreMutations.SetLoading, false);

      return completed;
    },
    async confermaVariazioneSubArrayOrdineMTM({commit}, request: ConfermaVariazioneSubArrayMTMRequest): Promise<boolean> {
      let completed = false;

      try {
        commit(StoreMutations.SetLoading, true);

        const result = await hub.confermaVariazioneSubArrayOrdineMTM(request);
        completed = result.eseguitaConSuccesso;

        if(completed) {
          let ordine: OrdineMTM | null = await hub.getOrdineMTM(request.idOrdine);
          commit(StoreMutations.SetOrdineMTM, ordine);
        } else{
          commit(StoreMutations.AddMessaggi, result.errori.map( e => {return {
            tipo: TipoMessaggioNotifica.Errore,
            message: e,
            showed: false
          }}));
        }
      }
      catch(error) {
        console.error("errore aggiornamento variazione testata ordine MTM: " + error);
        completed = false;
      }
      commit(StoreMutations.SetLoading, false);

      return completed;
    },
    async confermaVariazioneArrayItemsOrdineMTM({commit}, request: ConfermaVariazioneTestataArrayItemsRequest): Promise<boolean> {
      let completed = false;

      try {
        commit(StoreMutations.SetLoading, true);

        const result = await hub.confermaVariazioneArrayItemsOrdineMTM(request);
        completed = result.eseguitaConSuccesso;

        if(completed) {
          let ordine: OrdineMTM | null = await hub.getOrdineMTM(request.idOrdine);
          commit(StoreMutations.SetOrdineMTM, ordine);
        } else{
          commit(StoreMutations.AddMessaggi, result.errori.map( e => {return {
            tipo: TipoMessaggioNotifica.Errore,
            message: e,
            showed: false
          }}));
        }
      }
      catch(error) {
        console.error("errore aggiornamento variazione testata ordine MTM: " + error);
        completed = false;
      }
      commit(StoreMutations.SetLoading, false);

      return completed;
    },
    async getVenduto({commit}, finder: FinderVenduto): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let venduto: PagedList<GruppoVenduto> = await hub.getVenduto(finder);
        commit(StoreMutations.SetVenduto, venduto);
      }
      catch(error) {
        console.error("errore richiesta dati venduto per stagione " + finder.idStagione + "... Errore: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async getSpedizioni({commit}, finder: FinderSpedizioni): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let spedizioni: PagedList<Spedizione> = await hub.getSpedizioni(finder);
        commit(StoreMutations.SetSpedizioni, spedizioni);
      }
      catch(error) {
        console.error("errore lettura ordini: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async getLavorazioniFornitore({commit}, finder: FinderLavorazioni): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let lavorazioni: PagedList<LavorazioneSlim> = await hub.getLavorazioniFornitore(finder);
        commit(StoreMutations.SetLavorazioni, lavorazioni);
      }
      catch(error) {
        console.error("errore lettura lavorazioni: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async getLavorazioni({commit}, ids: string[]): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let lavorazioni: Lavorazione[] = await hub.getLavorazioni(ids);
        commit(StoreMutations.SetGruppoLavorazioni, lavorazioni);
      }
      catch(error) {
        console.error("errore lettura lavorazioni da lista id: " + error);
      }
      commit(StoreMutations.SetLoading, false);
      return true;
    },
    async getGruppoLavorazioniPerStagione({commit}, finder: FinderGruppoLavorazioniPerStagione): Promise<any> {
      try {
        commit(StoreMutations.SetGruppoLavorazioniPerStagioneLoading, true);
        let gruppo: PagedList<GruppoLavorazioniPerStagione> = await hub.getGruppoLavorazioniPerStagione(finder);
        commit(StoreMutations.SetGruppoLavorazioniPerStagione, gruppo);
      }
      catch(error) {
        console.error("errore lettura gruppo lavorazioni per stagione: " + error);
      }
      commit(StoreMutations.SetGruppoLavorazioniPerStagioneLoading, false);
      return true;
    },
    async getGruppoLavorazioniPerStagioneDataSources({commit}, finder: FinderGruppoLavorazioniPerStagione): Promise<any> {
      try {
        commit(StoreMutations.SetGruppoLavorazioniPerStagioneLoading, true);
        let elencoStagioni: TextValueItem[] = await hub.getGruppoLavorazioniPerStagioneElencoStagioni(finder);
        commit(StoreMutations.SetGruppoLavorazioniPerStagioneElencoStagioni, elencoStagioni);
      }
      catch(error) {
        console.error("errore lettura elenco fasi gruppo lavorazioni per stagione: " + error);
      }
      commit(StoreMutations.SetGruppoLavorazioniPerStagioneLoading, false);
      return true;
    },

    async getGruppoLavorazioniPerFase({commit}, finder: FinderGruppoLavorazioniPerFase): Promise<any> {
      try {
        commit(StoreMutations.SetGruppoLavorazioniPerFaseLoading, true);
        let gruppo: PagedList<GruppoLavorazioniPerFase> = await hub.getGruppoLavorazioniPerFase(finder);
        commit(StoreMutations.SetGruppoLavorazioniPerFase, gruppo);
      }
      catch(error) {
        console.error("errore lettura gruppo lavorazioni per fase: " + error);
      }
      commit(StoreMutations.SetGruppoLavorazioniPerFaseLoading, false);
      return true;
    },
    async getGruppoLavorazioniPerFaseDataSources({commit}, finder: FinderGruppoLavorazioniPerFase): Promise<any> {
      try {
        commit(StoreMutations.SetGruppoLavorazioniPerFaseLoading, true);
        let elencoFasi: TextValueItem[] = await hub.getGruppoLavorazioniPerFaseElencoFasi(finder);
        let elencoStagioni: TextValueItem[] = await hub.getGruppoLavorazioniPerFaseElencoStagioni(finder);
        commit(StoreMutations.SetGruppoLavorazioniPerFaseElencoFasi, elencoFasi);
        commit(StoreMutations.SetGruppoLavorazioniPerFaseElencoStagioni, elencoStagioni);
      }
      catch(error) {
        console.error("errore lettura elenco fasi gruppo lavorazioni per fase: " + error);
      }
      commit(StoreMutations.SetGruppoLavorazioniPerFaseLoading, false);
      return true;
    },
    async getGruppoLavorazioniPerConsegna({commit}, finder: FinderGruppoLavorazioniPerConsegna): Promise<any> {
      try {
        commit(StoreMutations.SetGruppoLavorazioniPerConsegnaLoading, true);
        let gruppo: PagedList<GruppoLavorazioniPerConsegna> = await hub.getGruppoLavorazioniPerConsegna(finder);
        commit(StoreMutations.SetGruppoLavorazioniPerConsegna, gruppo);
      }
      catch(error) {
        console.error("errore lettura gruppo lavorazioni per consegna: " + error);
      }
      commit(StoreMutations.SetGruppoLavorazioniPerConsegnaLoading, false);
      return true;
    },
    async getGruppoLavorazioniPerConsegnaDataSources({commit}, finder: FinderGruppoLavorazioniPerConsegna): Promise<any> {
      try {
        commit(StoreMutations.SetGruppoLavorazioniPerConsegnaLoading, true);
        let elencoStagioni: TextValueItem[] = await hub.getGruppoLavorazioniPerConsegnaElencoStagioni(finder);
        let elencoConsegne : TextValueItem[] = await hub.getGruppoLavorazioniPerConsegnaElencoConsegne(finder);
        commit(StoreMutations.SetGruppoLavorazioniPerConsegnaElencoStagioni, elencoStagioni);
        commit(StoreMutations.SetGruppoLavorazioniPerConsegnaElencoConsegne, elencoConsegne);
      }
      catch(error) {
        console.error("errore lettura elenco fasi gruppo lavorazioni per consegna: " + error);
      }
      commit(StoreMutations.SetGruppoLavorazioniPerConsegnaLoading, false);
      return true;
    },


    async getGruppoLavorazioniPerLotto({commit}, finder: FinderGruppoLavorazioniPerLotto): Promise<any> {
      try {
        commit(StoreMutations.SetGruppoLavorazioniPerLottoLoading, true);
        let gruppo: PagedList<GruppoLavorazioniPerLotto> = await hub.getGruppoLavorazioniPerLotto(finder);
        commit(StoreMutations.SetGruppoLavorazioniPerLotto, gruppo);
      }
      catch(error) {
        console.error("errore lettura gruppo lavorazioni per lotto: " + error);
      }
      commit(StoreMutations.SetGruppoLavorazioniPerLottoLoading, false);
      return true;
    },
    async getGruppoLavorazioniPerLottoDataSources({commit}, finder: FinderGruppoLavorazioniPerLotto): Promise<any> {
      try {
        commit(StoreMutations.SetGruppoLavorazioniPerLottoLoading, true);
        let elencoStagioni: TextValueItem[] = await hub.getGruppoLavorazioniPerLottoElencoStagioni(finder);
        let elencoLotti: TextValueItem[] = await hub.getGruppoLavorazioniPerLottoElencoLotti(finder);
        commit(StoreMutations.SetGruppoLavorazioniPerLottoElencoStagioni, elencoStagioni);
        commit(StoreMutations.SetGruppoLavorazioniPerLottoElencoLotti, elencoLotti);
      }
      catch(error) {
        console.error("errore lettura elenco fasi gruppo lavorazioni per lotto: " + error);
      }
      commit(StoreMutations.SetGruppoLavorazioniPerLottoLoading, false);
      return true;
    },

    async getLavorazione({commit}, id: string): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        // caricamento lavorazione
        let lavorazione: Lavorazione | null = await hub.getLavorazione(id);
        commit(StoreMutations.SetLavorazione, lavorazione);
        // caricamento azioni possibili sulla lavorazione
        let azioni: string[] = await hub.getAzioniPossibiliPerLavorazione(id);
        commit(StoreMutations.SetAzioniLavorazione, azioni);
      }
      catch(error) {
        console.error("errore lettura lavorazione: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async getLavorazionePerRigaSpedizioneDaLid({commit}, id: string): Promise<any> {
      try {
        commit(StoreMutations.SetLavorazionePerRigaDettaglioPerLidLoading, true);
        // caricamento lavorazione
        let lavorazione: Lavorazione | null = await hub.searchLavorazione(id);
        commit(StoreMutations.SetLavorazionePerRigaDettaglioDaLid, lavorazione);
        // caricamento azioni possibili sulla lavorazione
      }
      catch(error) {
        console.error("errore lettura lavorazione: " + error);
      }
      commit(StoreMutations.SetLavorazionePerRigaDettaglioPerLidLoading, false);
    },
    async aggiungiRigaSpedizioneDaLavorazione({commit, dispatch}, {idSpedizione, idLavorazione} ): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let esito: EsitoOperazione = await hub.aggiungiRigaSpedizioneDaLavorazione(idSpedizione, idLavorazione);
        if(esito.eseguitaConSuccesso) {
          await dispatch(StoreActions.GetSpedizione, idSpedizione);
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Info,
            message: "La riga è stata aggiunta con successo.",
            showed: false
          }]);
        } else {
          commit(StoreMutations.SetMessaggiErrore, esito.errori);
        }
      }
      catch(error) {
        console.error("errore aggiornamento azioni ordine: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async aggiungiRigaSpedizioneDaEpcLavorazione({commit, dispatch}, {idSpedizione, epcLavorazione} ) {
      try {
        let result = false;
        commit(StoreMutations.SetLoading, true);
        let esito: EsitoOperazioneConValoreDiRitorno = await hub.aggiungiRigaSpedizioneDaEpcLavorazione(idSpedizione, epcLavorazione);
        if(esito.eseguitaConSuccesso) {
          result = true;
          await dispatch(StoreActions.GetSpedizione, idSpedizione);
          if(esito.valoreDiRitorno == 'new'){
            commit(StoreMutations.AddMessaggi, [{
              tipo: TipoMessaggioNotifica.Info,
              message: "Il seriale è stato aggiunto con successo.",
              showed: false
            }]);
          } else{
            commit(StoreMutations.AddMessaggi, [{
              tipo: TipoMessaggioNotifica.Info,
              message: `Il seriale EPC ${epcLavorazione} è già presente.`,
              showed: false
            }]);
          }
        } else {
          commit(StoreMutations.SetMessaggiErrore, esito.errori);
        }
        commit(StoreMutations.SetLoading, false);
        return result;
      }
      catch(error) {
        console.error("errore aggiornamento azioni ordine: " + error);
      }
    },
    async eliminaRigaSpedizioneDaLavorazione({commit, dispatch}, {idSpedizione, idLavorazione} ): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let esito: EsitoOperazione = await hub.eliminaRigaSpedizioneDaIdLavorazione(idSpedizione, idLavorazione);
        if(esito.eseguitaConSuccesso) {
          await dispatch(StoreActions.GetSpedizione, idSpedizione);
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Info,
            message: "La riga è stata eliminata con successo.",
            showed: false
          }]);
        } else {
          commit(StoreMutations.SetMessaggiErrore, esito.errori);
        }
      }
      catch(error) {
        console.error("errore aggiornamento azioni ordine: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async eliminaSpedizione({commit, dispatch}, idSpedizione ): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let esito: EsitoOperazione = await hub.eliminaSpedizione(idSpedizione);
        if(esito.eseguitaConSuccesso) {
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Info,
            message: "La spedizione è stata eliminata con successo.",
            showed: false
          }]);
        } else {
          commit(StoreMutations.SetMessaggiErrore, esito.errori);
        }
      }
      catch(error) {
        console.error("errore aggiornamento azioni ordine: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async getDistintaDinamica({state, commit}, id: string): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        // caricamento distinta lavorazione
        let distinta: Distinta | null = await hub.getDistintaDinamica(id);
        let lavorazione = Object.assign({}, state.lavorazioneCorrente);

        if(lavorazione != null && distinta != null) {
          lavorazione.distintaDinamica = distinta;
          commit(StoreMutations.SetLavorazione, lavorazione);
        }
        if(distinta == null){
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Errore,
            message: "Non è stata trovata nessuna distinta dinamica associata alla lavorazione",
            showed: false
          }]);
        }
      }
      catch(error) {
        console.error("errore caricamento distinta dinamica: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async getDistintaStaticaDaStagioneModelloColorePerLavorazione({state, commit}, smc: { stagione: string, modello: string, colore: string }): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        // caricamento distinta lavorazione
        let distinta: Distinta | null = await hub.getDistintaStaticaDaStagioneModelloColore(smc.stagione, smc.modello, smc.colore);
        let lavorazione = Object.assign({}, state.lavorazioneCorrente);
        if(lavorazione != null && distinta != null) {
          lavorazione.distintaStatica = distinta;
          commit(StoreMutations.SetLavorazione, lavorazione);
        }
        if(distinta == null){
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Errore,
            message: "Non è stata trovata nessuna distinta statica associata alla lavorazione",
            showed: false
          }]);
        }
      }
      catch(error) {
        console.error("errore caricamento distinta statica: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async getDistintaStaticaDaStagioneModelloColore({state, commit}, smc: { stagione: string, modello: string, colore: string }): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        // caricamento distinta lavorazione
        let distinta: Distinta | null = await hub.getDistintaStaticaDaStagioneModelloColore(smc.stagione, smc.modello, smc.colore);
        commit(StoreMutations.SetDistintaStatica, distinta);
      }
      catch(error) {
        console.error("errore caricamento distinta statica: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async updateLavorazione({commit, state}, lavorazione: Lavorazione): Promise<any> {
      try {
        let messaggi: MessaggioNotifica[] = [];

        // aggiornamento eventuale lavorazione correntemente selezionato
        if(state.lavorazioneCorrente && state.lavorazioneCorrente.id === lavorazione.id) {
          commit(StoreMutations.SetLavorazione, lavorazione);
          // aggiorno azioni possibili sulla lavorazione
          let azioni: string[] = await hub.getAzioniPossibiliPerLavorazione(lavorazione.id);
          commit(StoreMutations.SetAzioniLavorazione, azioni);
          // notiifco aggiornamento in background
          messaggi.push({
            tipo: TipoMessaggioNotifica.Info,
            message: "La lavorazione corrente è stata aggiornata in seguito ad una modifica eseguita sul server.",
            showed: false
          });
        }

        // aggiornamento eventuale lavorazione slim contenuto nella lista corrente
        if(state.listaLavorazioni && state.listaLavorazioni.length > 0)
        {
          if(state.listaLavorazioni.findIndex(l => l.id === lavorazione.id) >= 0) {
            commit(StoreMutations.UpdateLavorazioneInLista, lavorazione);

            // notiifco aggiornamento in background
            if(messaggi.length == 0) messaggi.push({
              tipo: TipoMessaggioNotifica.Info,
              message: `La lavorazione "${lavorazione.id}" è stata aggiornata in seguito ad una modifica eseguita sul server.`,
              showed: false
            });
          }
        }

        // aggiornamento eventuale lavorazione contenuto nell'ordine correntemente caricato
        if(state.ordineCorrente && state.ordineCorrente.lavorazioni && state.ordineCorrente.lavorazioni.length > 0) {
          if(state.ordineCorrente.lavorazioni.findIndex(l => l.id === lavorazione.id) >= 0) {
            commit(StoreMutations.UpdateLavorazioneInOrdine, lavorazione);

            // notiifco aggiornamento in background
            if(messaggi.length == 0) messaggi.push({
              tipo: TipoMessaggioNotifica.Info,
              message: `La lavorazione "${lavorazione.id}" è stata aggiornata in seguito ad una modifica eseguita sul server.`,
              showed: false
            });
          }
        }

        // aggiornamento eventuale lavorazione contenuto nel gruppo di lavorazioni corrente
        if(state.gruppoLavorazioni && state.gruppoLavorazioni.length > 0)
        {
          if(state.gruppoLavorazioni.findIndex(l => l.id === lavorazione.id) >= 0) {
            commit(StoreMutations.UpdateLavorazioneInGruppo, lavorazione);

            // notiifco aggiornamento in background
            if(messaggi.length == 0) messaggi.push({
              tipo: TipoMessaggioNotifica.Info,
              message: `La lavorazione "${lavorazione.id}" è stata aggiornata in seguito ad una modifica eseguita sul server.`,
              showed: false
            });
          }
        }

        commit(StoreMutations.AddMessaggi, messaggi);
      }
      catch(error) {
        console.error("errore aggiornamento lavorazione: " + error);
      }
    },
    async updateGruppoLavorazioni({commit, state}, ids: string[]): Promise<any> {
      try {
        if(ids && ids.length > 0) {
          await store.dispatch(StoreActions.GetAzioniPossibiliPerLavorazioni, ids);

          let messaggi: MessaggioNotifica[] = [{
            tipo: TipoMessaggioNotifica.Info,
            message: "Alcune lavorazioni sono state aggiornate in seguito ad una modifica eseguita sul server.",
            showed: false
          }];

          commit(StoreMutations.AddMessaggi, messaggi);
        }
      }
      catch(error) {
        console.error("errore aggiornamento lavorazione: " + error);
      }
    },
    async getAzioniPossibiliPerLavorazione({commit}, id: string): Promise<any> {
      try {
        let azioni: string[] = await hub.getAzioniPossibiliPerLavorazione(id);
        commit(StoreMutations.SetAzioniLavorazioni, azioni);
      }
      catch(error) {
        console.error("errore richiesta azioni per lavorazione: " + error);
      }
    },
    async getAzioniPossibiliPerLavorazioni({commit}, ids: string[]): Promise<any> {
      try {
        let azioni: AzioniLavorazione[] = await hub.getAzioniPossibiliPerLavorazioni(ids);
        commit(StoreMutations.SetAzioniLavorazioni, azioni);
      }
      catch(error) {
        console.error("errore richiesta azioni per lavorazione: " + error);
      }
    },
    async getModelliSchedeDaModelloEStagione({commit}, request: {modello: string, stagione: string}): Promise<any> {
      try {
        let azioni: string[] = await hub.getSchedeModelliDaModelloEStagione(request.modello, request.stagione);
        commit(StoreMutations.SetModelliSchede, azioni);
      }
      catch(error) {
        console.error("errore richiesta schede modelli per ordine: " + error);
      }
    },

    async richiediVariazioneLavorazione({commit, dispatch}, { id, variazione }): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let esito: EsitoAzione = await hub.richiediVariazioneLavorazione(id, variazione);
        if(esito.eseguitaConSuccesso) {
          await dispatch(StoreActions.GetLavorazione, id);
        } else {
          commit(StoreMutations.SetMessaggiErrore, esito.errori);
        }
      }
      catch(error) {
        console.error("errore aggiornamento azioni lavorazione: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async salvaDatiAggiuntiviOrdine({commit, dispatch}, request: RequestSalvaDatiAggiuntiviOrdine ): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let esito: EsitoAzione = await hub.salvaDatiAggiuntiviOrdine(request);
        if(esito.eseguitaConSuccesso) {
          await dispatch(StoreActions.GetOrdine, request.idOrdine);
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Info,
            message: "Il salvataggio dei dati aggiuntivi è avvenuto con successo.",
            showed: false
          }]);
        } else {
          commit(StoreMutations.SetMessaggiErrore, esito.errori);
        }
      }
      catch(error) {
        console.error("errore aggiornamento azioni ordine: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async salvaDatiAggiuntiviLavorazione({commit, dispatch}, request: RequestSalvaDatiAggiuntiviLavorazione ): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let esito: EsitoAzione = await hub.salvaDatiAggiuntiviLavorazione(request);
        if(esito.eseguitaConSuccesso) {
          await dispatch(StoreActions.GetLavorazione, request.idLavorazione);
          commit(StoreMutations.AddMessaggi, [{
            tipo: TipoMessaggioNotifica.Info,
            message: "Il salvataggio dei dati aggiuntivi è avvenuto con successo.",
            showed: false
          }]);
        } else {
          commit(StoreMutations.SetMessaggiErrore, esito.errori);
        }
      }
      catch(error) {
        console.error("errore aggiornamento azioni lavorazione: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async accettaLavorazione({commit, dispatch}, id): Promise<any> {
      return await dispatch(StoreActions.EseguiAzionePerLavorazione, { id: id, azione: Azione.ACCETTA});
    },
    async forzaAccettazioneParteBc({commit, dispatch}, id): Promise<any> {
      return await dispatch(StoreActions.EseguiAzionePerLavorazione, { id: id, azione: Azione.FORZA_ACCETTAZIONE_DA_PARTE_DI_BC});
    },
    async consegnaFornitore({commit, dispatch}, id): Promise<any> {
      return await dispatch(StoreActions.EseguiAzionePerLavorazione, { id: id, azione: Azione.CONSEGNA_A_FORNITORE});
    },
    async forzaConsegnaFornitoreBc({commit, dispatch}, id): Promise<any> {
      return await dispatch(StoreActions.EseguiAzionePerLavorazione, { id: id, azione: Azione.FORZA_CONSEGNA_A_FORNITORE_DA_PARTE_DI_BC});
    },
    async confermaConsegna({commit, dispatch}, id): Promise<any> {
      return await dispatch(StoreActions.EseguiAzionePerLavorazione, { id: id, azione: Azione.REGISTRA_CONSEGNA_A_FORNITORE});
    },
    async inizioLavorazione({commit, dispatch}, id): Promise<any> {
      return await dispatch(StoreActions.EseguiAzionePerLavorazione, { id: id, azione: Azione.INIZIA_LAVORAZIONE});
    },
    async completaLavorazione({commit, dispatch}, id): Promise<any> {
      return await dispatch(StoreActions.EseguiAzionePerLavorazione, { id: id, azione: Azione.COMPLETA_LAVORAZIONE});
    },
    async riconsegnaABc({commit, dispatch}, id): Promise<any> {
      return await dispatch(StoreActions.EseguiAzionePerLavorazione, { id: id, azione: Azione.RICONSEGNA_A_BC});
    },
    async registraRientro({commit, dispatch}, id): Promise<any> {
      return await dispatch(StoreActions.EseguiAzionePerLavorazione, { id: id, azione: Azione.REGISTRA_RIENTRO});
    },
    async eseguiAzionePerLavorazione({commit, dispatch}, azioneLav: { id: string, azione: Azione } ): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let esito: EsitoAzione = await hub.eseguiAzionePerLavorazione(azioneLav.azione, azioneLav.id);
        if(esito.eseguitaConSuccesso) {
          await dispatch(StoreActions.GetLavorazione, azioneLav.id);
        } else {
          commit(StoreMutations.SetMessaggiErrore, esito.errori);
        }
      }
      catch(error) {
        console.error("errore variazione lavorazione: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },
    async invioProgresso({commit, dispatch}, progresso: ProgressoLavorazione): Promise<any> {
      try {
        commit(StoreMutations.SetLoading, true);
        let esito: EsitoAzione = await hub.aggiornaProgressoLavorazione(progresso);
        if(esito.eseguitaConSuccesso) {
          await dispatch(StoreActions.GetLavorazione, progresso.idLavorazione);
        } else {
          commit(StoreMutations.SetMessaggiErrore, esito.errori);
        }
      }
      catch(error) {
        console.error("errore invio progresso lavorazione: " + error);
      }
      commit(StoreMutations.SetLoading, false);
    },

    async accettaLavorazioni({commit, dispatch}, ids: string[]): Promise<any> {
      return await dispatch(StoreActions.EseguiAzionePerLavorazioni, { ids: ids, azione: Azione.ACCETTA});
    },
    async consegnaFornitoreLavorazioni({commit, dispatch}, ids: string[]): Promise<any> {
      return await dispatch(StoreActions.EseguiAzionePerLavorazioni, { ids: ids, azione: Azione.CONSEGNA_A_FORNITORE});
    },
    async confermaConsegnaLavorazioni({commit, dispatch}, ids: string[]): Promise<any> {
      return await dispatch(StoreActions.EseguiAzionePerLavorazioni, { ids: ids, azione: Azione.REGISTRA_CONSEGNA_A_FORNITORE});
    },
    async inizioLavorazioni({commit, dispatch}, ids: string[]): Promise<any> {
      return await dispatch(StoreActions.EseguiAzionePerLavorazioni, { ids: ids, azione: Azione.INIZIA_LAVORAZIONE});
    },
    async completaLavorazioni({commit, dispatch}, ids: string[]): Promise<any> {
      return await dispatch(StoreActions.EseguiAzionePerLavorazioni, { ids: ids, azione: Azione.COMPLETA_LAVORAZIONE});
    },
    async eseguiAzionePerLavorazioni({commit, dispatch}, azioniLav: { ids: string[], azione: Azione } ): Promise<string[]> {
      let idLavorazioniModificate: string[] = [];
      try {
        commit(StoreMutations.SetLoading, true);
        let esiti: EsitoAzione[] = await hub.eseguiAzionePerLavorazioni(azioniLav.azione, azioniLav.ids);

        esiti.forEach(esito => {
          if(esito.eseguitaConSuccesso) {
            idLavorazioniModificate.push(esito.idLavorazioneDpc);
          }
          else {
            commit(StoreMutations.SetMessaggiErrore, esito.errori);
          }
        });
      }
      catch(error) {
        console.error("errore variazione lavorazione: " + error);
      }
      commit(StoreMutations.SetLoading, false);
      return idLavorazioniModificate;
    },
    async richiediVariazioniLavorazioni({commit, dispatch}, { ids, variazione }): Promise<string[]> {
      let idLavorazioniModificate: string[] = [];
      try {
        commit(StoreMutations.SetLoading, true);
        let esiti: EsitoAzione[] = await hub.richiediVariazioniLavorazioni(ids, variazione);
        esiti.forEach(esito => {
          if(esito.eseguitaConSuccesso) {
            idLavorazioniModificate.push(esito.idLavorazioneDpc);
          }
          else {
            commit(StoreMutations.SetMessaggiErrore, esito.errori);
          }
        });
      }
      catch(error) {
        console.error("errore aggiornamento azioni lavorazione: " + error);
      }
      commit(StoreMutations.SetLoading, false);
      return idLavorazioniModificate;
    },
    async invioProgressi({commit, dispatch}, progressi: ProgressoLavorazione[]): Promise<boolean> {
      let retVal = false;

      try {
        commit(StoreMutations.SetLoading, true);
        let esito: EsitoAzione = await hub.aggiornaProgressiLavorazione(progressi);
        if(!esito.eseguitaConSuccesso) {
        //   await dispatch(StoreActions.GetLavorazione, progresso.idLavorazione);
        // } else {
          commit(StoreMutations.SetMessaggiErrore, esito.errori);
        }
        retVal = esito.eseguitaConSuccesso;
      }
      catch(error) {
        console.error("errore invio progresso lavorazione: " + error);
      }
      commit(StoreMutations.SetLoading, false);
      return retVal;
    },

    //STAMPA ETICHETTE
    async stampaEtichettaPerLavorazioneETaglia({state, commit}, {operazione, idLavorazione} ): Promise<boolean>{
      commit(StoreMutations.SetStampaEtichetteLoading, true);
      let result = true;
      try{
        const response = await hub.stampaEtichettaPerLavorazioneETaglia(idLavorazione, state.uiLavorazione.stampaEtichette.indiceTaglia, operazione);
        commit(StoreMutations.AddMessaggi, [{
          tipo: TipoMessaggioNotifica.Info,
          message: `Operazione effettuata con successo`,
          showed: false
        }]);
        result = response.eseguitaConSuccesso;
      }
      catch(error)
      {
        commit(StoreMutations.SetMessaggiErrore, error);
        result = false;
      }
      commit(StoreMutations.SetStampaEtichetteLoading, false);
      return result;
    },

    async stampaEtichettePerOrdine({state, commit}, {operazione, idOrdine} ): Promise<boolean>{
      commit(StoreMutations.SetStampaEtichetteLoading, true);
      let result = true;
      try{
        const response = await hub.stampaEtichettePerOrdine(idOrdine, operazione);
        commit(StoreMutations.AddMessaggi, [{
          tipo: TipoMessaggioNotifica.Info,
          message: `Operazione effettuata con successo`,
          showed: false
        }]);
        result = response.eseguitaConSuccesso;
      }
      catch(error)
      {
        commit(StoreMutations.SetMessaggiErrore, error);
        result = false;
      }
      commit(StoreMutations.SetStampaEtichetteLoading, false);
      return result;
    },

    async stampaEtichettePerOrdineMTM({state, commit}, {operazione, idOrdine} ): Promise<boolean>{
      commit(StoreMutations.SetStampaEtichetteLoading, true);
      let result = true;
      try{
        const response = await hub.stampaEtichettePerOrdineMTM(idOrdine, operazione);
        commit(StoreMutations.AddMessaggi, [{
          tipo: TipoMessaggioNotifica.Info,
          message: `Operazione effettuata con successo`,
          showed: false
        }]);
        result = response.eseguitaConSuccesso;
      }
      catch(error)
      {
        commit(StoreMutations.SetMessaggiErrore, error);
        result = false;
      }
      commit(StoreMutations.SetStampaEtichetteLoading, false);
      return result;
    },

    async operazioniEtichetteDremeDisponibiliPerLavorazione({commit}, idLavorazione): Promise<boolean>{
      commit(StoreMutations.SetGetOperazioniDisponibiliLoading, true);
      let result = true;
      try{
        const response = await hub.getOperazioniStampaBrehmeDisponibiliPerLavorazione(idLavorazione);

        commit(StoreMutations.SetStampaBremeDisponibilePerLavorazione, response);
      }
      catch(error)
      {
        commit(StoreMutations.SetMessaggiErrore, error);
      }
      commit(StoreMutations.SetGetOperazioniDisponibiliLoading, false);
      return result;
    },

    async operazioniEtichetteDremeDisponibiliPerOrdine({commit}, idOrdine): Promise<boolean>{
      commit(StoreMutations.SetGetOperazioniDisponibiliLoading, true);
      let result = true;
      try{
        const response = await hub.getOperazioniStampaBrehmeDisponibiliPerOrdine(idOrdine);

        commit(StoreMutations.SetStampaBremeDisponibilePerOrdine, response);
      }
      catch(error)
      {
        commit(StoreMutations.SetMessaggiErrore, error);
      }
      commit(StoreMutations.SetGetOperazioniDisponibiliLoading, false);
      return result;
    },

    async getResetEPCDisponibile({commit} ): Promise<boolean>{
      let result = true;
      try{
        const response = await hub.getResetEPCDisponibile();

        commit(StoreMutations.SetResetEpcDisponibile, response);
      }
      catch(error)
      {
        commit(StoreMutations.SetMessaggiErrore, error);
      }
      return result;
    },

    async getStampaEtichetteRfidDisponibile({commit} ): Promise<boolean>{
      let result = true;
      try{
        const response = await hub.getStampaEtichetteRfidDisponibile();

        commit(StoreMutations.SetStampaEtichetteRfidDisponibile, response);
      }
      catch(error)
      {
        commit(StoreMutations.SetMessaggiErrore, error);
      }
      return result;
    },

    async getStampaEtichetteNoRfidDisponibile({commit} ): Promise<boolean>{
      let result = true;
      try{
        const response = await hub.getStampaEtichetteNoRfidDisponibile();

        commit(StoreMutations.SetStampaEtichetteNoRfidDisponibile, response);
      }
      catch(error)
      {
        commit(StoreMutations.SetMessaggiErrore, error);
      }
      return result;
    }

  } as ActionTree<RootState, RootState>
